export default __webpack_public_path__ + "static/tietoevryoffice-5ec1f6b391ca0936e7c95ab4bcd74371.png";